"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkCommentDialog = void 0;
var bulk_comment_dialog_component_1 = require("./bulk-comment-dialog.component");
Object.defineProperty(exports, "BulkCommentDialog", { enumerable: true, get: function () { return bulk_comment_dialog_component_1.BulkCommentDialog; } });
